// export const USCAregions: Array<any> = [{
//     title: 'Alabama',
//     value: 'AL'
// }, {
//     title: 'Alaska',
//     value: 'AK'
// }, {
//     title: 'American Samoa',
//     value: 'AS'
// }, {
//     title: 'Arizona',
//     value: 'AZ'
// }, {
//     title: 'Arkansas',
//     value: 'AR'
// }, {
//     title: 'British Columbia',
//     value: 'BC'
// }, {
//     title: 'California',
//     value: 'CA'
// }, {
//     title: 'Colorado',
//     value: 'CO'
// }, {
//     title: 'Connecticut',
//     value: 'CT'
// }, {
//     title: 'Delaware',
//     value: 'DE'
// }, {
//     title: 'District Of Columbia',
//     value: 'DC'
// }, {
//     title: 'Federated States Of Micronesia',
//     value: 'FM'
// }, {
//     title: 'Florida',
//     value: 'FL'
// }, {
//     title: 'Georgia',
//     value: 'GA'
// }, {
//     title: 'Guam',
//     value: 'GU'
// }, {
//     title: 'Hawaii',
//     value: 'HI'
// }, {
//     title: 'Idaho',
//     value: 'ID'
// }, {
//     title: 'Illinois',
//     value: 'IL'
// }, {
//     title: 'Indiana',
//     value: 'IN'
// }, {
//     title: 'Iowa',
//     value: 'IA'
// }, {
//     title: 'Kansas',
//     value: 'KS'
// }, {
//     title: 'Kentucky',
//     value: 'KY'
// }, {
//     title: 'Louisiana',
//     value: 'LA'
// }, {
//     title: 'Maine',
//     value: 'ME'
// }, {
//     title: 'Manitoba',
//     value: 'MB'
// }, {
//     title: 'Marshall Islands',
//     value: 'MH'
// }, {
//     title: 'Maryland',
//     value: 'MD'
// }, {
//     title: 'Massachusetts',
//     value: 'MA'
// }, {
//     title: 'Michigan',
//     value: 'MI'
// }, {
//     title: 'Minnesota',
//     value: 'MN'
// }, {
//     title: 'Mississippi',
//     value: 'MS'
// }, {
//     title: 'Missouri',
//     value: 'MO'
// }, {
//     title: 'Montana',
//     value: 'MT'
// }, {
//     title: 'Nebraska',
//     value: 'NE'
// }, {
//     title: 'Nevada',
//     value: 'NV'
// }, {
//     title: 'New Brunswick',
//     value: 'NB'
// }, {
//     title: 'New Hampshire',
//     value: 'NH'
// }, {
//     title: 'New Jersey',
//     value: 'NJ'
// }, {
//     title: 'New Mexico',
//     value: 'NM'
// }, {
//     title: 'New York',
//     value: 'NY'
// }, {
//     title: 'Newfoundland and Labrador',
//     value: 'NL'
// }, {
//     title: 'North Carolina',
//     value: 'NC'
// }, {
//     title: 'North Dakota',
//     value: 'ND'
// }, {
//     title: 'Northern Mariana Islands',
//     value: 'MP'
// }, {
//     title: 'Nova Scotia',
//     value: 'NS'
// }, {
//     title: 'Northwest Territories',
//     value: 'NT'
// }, {
//     title: 'Nunavut',
//     value: 'NU'
// }, {
//     title: 'Ohio',
//     value: 'OH'
// }, {
//     title: 'Oklahoma',
//     value: 'OK'
// }, {
//     title: 'Ontario',
//     value: 'ON'
// }, {
//     title: 'Oregon',
//     value: 'OR'
// }, {
//     title: 'Palau',
//     value: 'PW'
// }, {
//     title: 'Pennsylvania',
//     value: 'PA'
// }, {
//     title: 'Prince Edward Island',
//     value: 'PE'
// }, {
//     title: 'Puerto Rico',
//     value: 'PR'
// }, {
//     title: 'Quebec',
//     value: 'QC'
// }, {
//     title: 'Rhode Island',
//     value: 'RI'
// }, {
//     title: 'Saskatchewan',
//     value: 'SK'
// }, {
//     title: 'South Carolina',
//     value: 'SC'
// }, {
//     title: 'South Dakota',
//     value: 'SD'
// }, {
//     title: 'Tennessee',
//     value: 'TN'
// }, {
//     title: 'Texas',
//     value: 'TX'
// }, {
//     title: 'Utah',
//     value: 'UT'
// }, {
//     title: 'Vermont',
//     value: 'VT'
// }, {
//     title: 'Virgin Islands',
//     value: 'VI'
// }, {
//     title: 'Virginia',
//     value: 'VA'
// }, {
//     title: 'Washington',
//     value: 'WA'
// }, {
//     title: 'West Virginia',
//     value: 'WV'
// }, {
//     title: 'Wisconsin',
//     value: 'WI'
// }, {
//     title: 'Wyoming',
//     value: 'WY'
// }, {
//     title: 'Yukon',
//     value: 'YT'
// }]

export const US_STATES: Array<any> = [
    {
        title: 'Alabama',
        value: 'AL',
    },
    {
        title: 'Alaska',
        value: 'AK',
    },
    {
        title: 'American Samoa',
        value: 'AS',
    },
    {
        title: 'Arizona',
        value: 'AZ',
    },
    {
        title: 'Arkansas',
        value: 'AR',
    },
    {
        title: 'California',
        value: 'CA',
    },
    {
        title: 'Colorado',
        value: 'CO',
    },
    {
        title: 'Connecticut',
        value: 'CT',
    },
    {
        title: 'Delaware',
        value: 'DE',
    },
    {
        title: 'District Of Columbia',
        value: 'DC',
    },
    {
        title: 'Federated States Of Micronesia',
        value: 'FM',
    },
    {
        title: 'Florida',
        value: 'FL',
    },
    {
        title: 'Georgia',
        value: 'GA',
    },
    {
        title: 'Guam',
        value: 'GU',
    },
    {
        title: 'Hawaii',
        value: 'HI',
    },
    {
        title: 'Idaho',
        value: 'ID',
    },
    {
        title: 'Illinois',
        value: 'IL',
    },
    {
        title: 'Indiana',
        value: 'IN',
    },
    {
        title: 'Iowa',
        value: 'IA',
    },
    {
        title: 'Kansas',
        value: 'KS',
    },
    {
        title: 'Kentucky',
        value: 'KY',
    },
    {
        title: 'Louisiana',
        value: 'LA',
    },
    {
        title: 'Maine',
        value: 'ME',
    },
    {
        title: 'Marshall Islands',
        value: 'MH',
    },
    {
        title: 'Maryland',
        value: 'MD',
    },
    {
        title: 'Massachusetts',
        value: 'MA',
    },
    {
        title: 'Michigan',
        value: 'MI',
    },
    {
        title: 'Minnesota',
        value: 'MN',
    },
    {
        title: 'Mississippi',
        value: 'MS',
    },
    {
        title: 'Missouri',
        value: 'MO',
    },
    {
        title: 'Montana',
        value: 'MT',
    },
    {
        title: 'Nebraska',
        value: 'NE',
    },
    {
        title: 'Nevada',
        value: 'NV',
    },
    {
        title: 'New Hampshire',
        value: 'NH',
    },
    {
        title: 'New Jersey',
        value: 'NJ',
    },
    {
        title: 'New Mexico',
        value: 'NM',
    },
    {
        title: 'New York',
        value: 'NY',
    },
    {
        title: 'North Carolina',
        value: 'NC',
    },
    {
        title: 'North Dakota',
        value: 'ND',
    },
    {
        title: 'Northern Mariana Islands',
        value: 'MP',
    },
    {
        title: 'Ohio',
        value: 'OH',
    },
    {
        title: 'Oklahoma',
        value: 'OK',
    },
    {
        title: 'Oregon',
        value: 'OR',
    },
    {
        title: 'Palau',
        value: 'PW',
    },
    {
        title: 'Pennsylvania',
        value: 'PA',
    },
    {
        title: 'Puerto Rico',
        value: 'PR',
    },
    {
        title: 'Rhode Island',
        value: 'RI',
    },
    {
        title: 'South Carolina',
        value: 'SC',
    },
    {
        title: 'South Dakota',
        value: 'SD',
    },
    {
        title: 'Tennessee',
        value: 'TN',
    },
    {
        title: 'Texas',
        value: 'TX',
    },
    {
        title: 'Utah',
        value: 'UT',
    },
    {
        title: 'Vermont',
        value: 'VT',
    },
    {
        title: 'Virgin Islands',
        value: 'VI',
    },
    {
        title: 'Virginia',
        value: 'VA',
    },
    {
        title: 'Washington',
        value: 'WA',
    },
    {
        title: 'West Virginia',
        value: 'WV',
    },
    {
        title: 'Wisconsin',
        value: 'WI',
    },
    {
        title: 'Wyoming',
        value: 'WY',
    },
].sort((a, b) => (a.title < b.title ? -1 : 1));

export const CANADA_PROVINCES: Array<any> = [
    {
        title: 'Alberta',
        value: 'AB',
    },
    {
        title: 'British Columbia',
        value: 'BC',
    },
    {
        title: 'Manitoba',
        value: 'MB',
    },
    {
        title: 'New Brunswick',
        value: 'NB',
    },
    {
        title: 'Newfoundland',
        value: 'NL',
        valueFMCSA: 'NF',
    },
    // {
    //     title: 'Newfoundland and Labrador',
    //     value: 'NL'
    // },
    {
        title: 'Nova Scotia',
        value: 'NS',
    },
    {
        title: 'Northwest Territories',
        value: 'NT',
    },
    {
        title: 'Nunavut',
        value: 'NU',
    },
    {
        title: 'Ontario',
        value: 'ON',
    },
    {
        title: 'Prince Edward Island',
        value: 'PE',
    },
    {
        title: 'Québec',
        value: 'QC',
    },
    {
        title: 'Saskatchewan',
        value: 'SK',
    },
    {
        title: 'Yukon',
        value: 'YT',
    },
].sort((a, b) => (a.title < b.title ? -1 : 1));

export const MEXICO_STATES: Array<any> = [
    {
        title: 'Aguascalientes',
        value: 'Ags.',
        valueFMCSA: 'AG',
    },
    {
        title: 'Baja California Norte',
        value: 'B.C.',
        valueFMCSA: 'BN',
    },
    {
        title: 'Baja California Sur',
        value: 'B.C.S.',
        valueFMCSA: 'BS',
    },
    {
        title: 'Coahuila',
        value: 'Coah.',
        valueFMCSA: 'CH',
    },
    {
        title: 'Chihuahua',
        value: 'Chih.',
        valueFMCSA: 'CI',
    },
    {
        title: 'Colima',
        value: 'Col.',
        valueFMCSA: 'CL',
    },
    {
        title: 'Campeche',
        value: 'Camp.',
        valueFMCSA: 'CP',
    },
    {
        title: 'Chiapas',
        value: 'Chis.',
        valueFMCSA: 'CS',
    },
    {
        title: 'Distrito Federal',
        value: 'CDMX',
        valueFMCSA: 'DF',
    },
    {
        title: 'Durango',
        value: 'Dgo.',
        valueFMCSA: 'DG',
    },
    {
        title: 'Guerrero',
        value: 'Gro.',
        valueFMCSA: 'GE',
    },
    {
        title: 'Guanajuato',
        value: 'Gto.',
        valueFMCSA: 'GJ',
    },
    {
        title: 'Hidalgo',
        value: 'Hgo.',
        valueFMCSA: 'HD',
    },
    {
        title: 'Jalisco',
        value: 'Jal.',
        valueFMCSA: 'JA',
    },
    {
        title: 'Michoacan',
        value: 'Mich.',
        valueFMCSA: 'MC',
    },
    {
        title: 'Morelos',
        value: 'Mor.',
        valueFMCSA: 'MR',
    },
    {
        title: 'Mexico',
        value: 'Méx.',
        valueFMCSA: 'MX',
    },
    {
        title: 'Nayarit',
        value: 'Nay.',
        valueFMCSA: 'NA',
    },
    {
        title: 'Nuevo Leon',
        value: 'N.L.',
        valueFMCSA: 'NL',
    },
    {
        title: 'Oaxaca',
        value: 'Oax.',
        valueFMCSA: 'OA',
    },
    {
        title: 'Puebla',
        value: 'Pue.',
        valueFMCSA: 'PU',
    },
    {
        title: 'Queretaro',
        value: 'Qro.',
        valueFMCSA: 'QE',
    },
    {
        title: 'Quintana Roo',
        value: 'Q.R.',
        valueFMCSA: 'QI',
    },
    {
        title: 'Sinaloa',
        value: 'Sin.',
        valueFMCSA: 'SI',
    },
    {
        title: 'San Luis Potosi',
        value: 'S.L.P.',
        valueFMCSA: 'SL',
    },
    {
        title: 'Sonora',
        value: 'Son.',
        valueFMCSA: 'SO',
    },
    {
        title: 'Tamaulipas',
        value: 'Tamps.',
        valueFMCSA: 'TA',
    },
    {
        title: 'Tabasco',
        value: 'Tab.',
        valueFMCSA: 'TB',
    },
    {
        title: 'Tlaxcala',
        value: 'Tlax.',
        valueFMCSA: 'TL',
    },
    {
        title: 'Veracruz',
        value: 'Ver.',
        valueFMCSA: 'VC',
    },
    {
        title: 'Yucatan',
        value: 'Yuc.',
        valueFMCSA: 'YU',
    },
    {
        title: 'Zacatecas',
        value: 'Zac.',
        valueFMCSA: 'ZA',
    },
].sort((a, b) => (a.title < b.title ? -1 : 1));

export const OTHER_STATES_PROVINCES: Array<any> = [
    {
        title: 'Other',
        value: 'OT',
    },
];

export const FUEL_TYPES: Array<any> = [
    {
        id: '01',
        name: 'Diesel',
    },
    {
        id: '02',
        name: 'Gasoline',
    },
    {
        id: '03',
        name: 'Ethanol',
    },
    {
        id: '04',
        name: 'Propane (LPG)',
    },
    {
        id: '05',
        name: 'Nature Gas (CNG)',
    },
    {
        id: '06',
        name: 'A-55',
    },
    {
        id: '07',
        name: 'E-85',
    },
    {
        id: '08',
        name: 'M-85',
    },
    {
        id: '09',
        name: 'Gasohol',
    },
    {
        id: '10',
        name: 'LNG',
    },
    {
        id: '11',
        name: 'Methanol',
    },
    {
        id: '12',
        name: 'Biodiesel',
    },
];

export const HOS_RULES = [
    {
        name: 'U.S. 60hr/7day',
        cons_offduty_hours: {
            bus: 8,
            truck: 10,
        },
        cons_drive_hours: {
            bus: 10,
            truck: 11,
        },
        cons_onduty_hours: {
            bus: 15,
            truck: 14,
        },
        adverse_conditions: 2,
        total_onduty_days: 7,
        total_onduty_hours: 60,
        cons_reset_hours: 34,
        workShiftLimit: 7.5,
        breakTime: 0.5,
    },
    {
        name: 'U.S. 70hr/8day',
        cons_offduty_hours: {
            bus: 8,
            truck: 10,
        },
        cons_drive_hours: {
            bus: 10,
            truck: 11,
        },
        cons_onduty_hours: {
            bus: 15,
            truck: 14,
        },
        adverse_conditions: 2,
        total_onduty_days: 8,
        total_onduty_hours: 70,
        cons_reset_hours: 34,
        workShiftLimit: 7.5,
        breakTime: 0.5,
    },
    {
        name: 'Intrastate 70hr/7day',
        cons_offduty_hours: {
            bus: 8,
            truck: 10,
        },
        cons_drive_hours: {
            bus: 10,
            truck: 11,
        },
        cons_onduty_hours: {
            bus: 15,
            truck: 14,
        },
        adverse_conditions: 2,
        total_onduty_days: 7,
        total_onduty_hours: 70,
        cons_reset_hours: 34,
        workShiftLimit: 7.5,
        breakTime: 0.5,
    },
    {
        name: 'Intrastate 80hr/8day',
        cons_offduty_hours: {
            bus: 8,
            truck: 10,
        },
        cons_drive_hours: {
            bus: 10,
            truck: 11,
        },
        cons_onduty_hours: {
            bus: 15,
            truck: 14,
        },
        adverse_conditions: 2,
        total_onduty_days: 8,
        total_onduty_hours: 80,
        cons_reset_hours: 34,
        workShiftLimit: 7.5,
        breakTime: 0.5,
    },
    {
        name: 'California 80hr/8day',
        cons_offduty_hours: {
            bus: 8,
            truck: 10,
        },
        cons_drive_hours: {
            bus: 10,
            truck: 11,
        },
        cons_onduty_hours: {
            bus: 15,
            truck: 14,
        },
        adverse_conditions: 2,
        total_onduty_days: 8,
        total_onduty_hours: 80,
        cons_reset_hours: 34,
        workShiftLimit: 7.5,
        breakTime: 0.5,
    },
    {
        name: 'California 112hr/8day',
        cons_offduty_hours: {
            bus: 8,
            truck: 10,
        },
        cons_drive_hours: {
            bus: 10,
            truck: 11,
        },
        cons_onduty_hours: {
            bus: 15,
            truck: 14,
        },
        adverse_conditions: 2,
        total_onduty_days: 8,
        total_onduty_hours: 112,
        cons_reset_hours: 34,
        workShiftLimit: 7.5,
        breakTime: 0.5,
    },
    {
        name: 'Texas 70hr/7day',
        cons_offduty_hours: {
            bus: 8,
            truck: 10,
        },
        cons_drive_hours: {
            bus: 10,
            truck: 11,
        },
        cons_onduty_hours: {
            bus: 15,
            truck: 14,
        },
        adverse_conditions: 2,
        total_onduty_days: 7,
        total_onduty_hours: 70,
        cons_reset_hours: 34,
        workShiftLimit: 7.5,
        breakTime: 0.5,
    },
    {
        name: 'CAN 70hr/7day',
        cons_offduty_hours: {
            bus: 8,
            truck: 8,
        },
        cons_drive_hours: {
            bus: 13,
            truck: 13,
        },
        cons_onduty_hours: {
            bus: 14,
            truck: 14,
        },
        adverse_conditions: 2,
        total_onduty_days: 7,
        total_onduty_hours: 70,
        cons_reset_hours: 36,
        workShiftLimit: 16,
        breakTime: 8,
    },
    {
        name: 'CAN 120hr/14day',
        cons_offduty_hours: {
            bus: 8,
            truck: 8,
        },
        cons_drive_hours: {
            bus: 13,
            truck: 13,
        },
        cons_onduty_hours: {
            bus: 14,
            truck: 14,
        },
        adverse_conditions: 2,
        total_onduty_days: 14,
        total_onduty_hours: 120,
        cons_reset_hours: 72,
        workShiftLimit: 16,
        breakTime: 8,
    },
    {
        name: 'CAN North 60th 80hr/7day',
        cons_offduty_hours: {
            bus: 8,
            truck: 8,
        },
        cons_drive_hours: {
            bus: 15,
            truck: 15,
        },
        cons_onduty_hours: {
            bus: 18,
            truck: 18,
        },
        adverse_conditions: 2,
        total_onduty_days: 7,
        total_onduty_hours: 80,
        cons_reset_hours: 36,
        workShiftLimit: 20,
        breakTime: 8,
    },
    {
        name: 'CAN North 60th 120hr/14day',
        cons_offduty_hours: {
            bus: 8,
            truck: 8,
        },
        cons_drive_hours: {
            bus: 15,
            truck: 15,
        },
        cons_onduty_hours: {
            bus: 18,
            truck: 18,
        },
        adverse_conditions: 2,
        total_onduty_days: 14,
        total_onduty_hours: 120,
        cons_reset_hours: 72,
        workShiftLimit: 20,
        breakTime: 8,
    },
];

export const VEHICLE_BODY_TYPE = [
    {
        name: 'Bus',
        abbr: 'BS',
        category: 'Bus',
    },
    {
        name: 'Mini Bus',
        abbr: 'MS',
        category: 'Bus',
    },
    {
        name: 'Pickup',
        abbr: 'PK',
        category: 'Truck',
    },
    {
        name: 'Road Tractor',
        abbr: 'RT',
        category: 'Truck',
    },
    {
        name: 'Single Truck',
        abbr: 'TK',
        category: 'Truck',
    },
    {
        name: 'Tractor',
        abbr: 'TR',
        category: 'Truck',
    },
    {
        name: 'Truck Tractor',
        abbr: 'TT',
        category: 'Truck',
    },
    {
        name: 'Taxi',
        abbr: 'TX',
        category: 'Bus',
    },
    {
        name: 'Van',
        abbr: 'VN',
        category: 'Bus',
    },
    {
        name: 'Wrecker',
        abbr: 'WK',
        category: 'Truck',
    },
];

export const SPECIFIED_RESET_RULES = [
    {
        name: 'CAN 70hr/7day',
        cons_reset_hours: 36,
        daysToGetRecapElogs: 2,
    },
    {
        name: 'CAN North 60th 80hr/7day',
        cons_reset_hours: 36,
        daysToGetRecapElogs: 2,
    },
    {
        name: 'CAN 120hr/14day',
        cons_reset_hours: 72,
        daysToGetRecapElogs: 3,
    },
    {
        name: 'CAN North 60th 120hr/14day',
        cons_reset_hours: 72,
        daysToGetRecapElogs: 3,
    },
];

export const ADMIN_LEVEL = {
    1: {
        lv: 1,
        descripation: 'FleetManager',
        instantLocation: true,
        org: {
            address: true,
            contactInfo: true,
            addAffiliatedCompanies: false,
        },
        driver: {
            create: true,
            update: true,
            delete: true,
        },
        vehicle: {
            update: true,
            showActivationDate: true,
        },
        driverLog: {
            recreateElogChart: true,
        },
        vehicleDvir: true,
        driverLogPdf: true,
        fmcsaEldWebService: true,
    },
    2: {
        lv: 2,
        descripation: 'OrgOwner',
        instantLocation: true,
        org: {
            address: true,
            contactInfo: true,
            addAffiliatedCompanies: false,
        },
        driver: {
            create: true,
            update: true,
            delete: true,
        },
        vehicle: {
            update: true,
            showActivationDate: true,
        },
        driverLog: {
            recreateElogChart: true,
        },
        vehicleDvir: true,
        driverLogPdf: true,
        fmcsaEldWebService: true,
    },
    3: {
        lv: 3,
        allOrgList: true,
        descripation: 'GoodLA',
        instantLocation: true,
        org: {
            addAffiliatedCompanies: false,
        },
        vehicleDvir: true,
        driverLogPdf: true,
        fmcsaEldWebService: true,
        iftaReport: true,
    },
    4: {
        lv: 4,
        allOrgList: true,
        descripation: 'CustomerService',
        instantLocation: true,
        historyLocationTracking: true,
        org: {
            address: true,
            contactInfo: true,
            accountLimits: true,
            addAffiliatedCompanies: true,
        },
        driver: {
            create: true,
            update: true,
            delete: true,
            resetPassword: true,
        },
        vehicle: {
            serialNumber: true,
            update: true,
            deviceReturnDate: true,
        },
        driverLog: {
            recreateElogChart: true,
            deleteAutoEvent: false,
        },
        vehicleDvir: true,
        driverLogPdf: true,
        fmcsaEldWebService: true,
        iftaReport: true,
        controlPanel: true,
        customerService: {
            modifyOrgCsm: true,
            modifyTask: true,
        },
    },
    5: {
        lv: 5,
        descripation: 'Sales',
        instantLocation: true,
        historyLocationTracking: true,
        org: {
            address: true,
            contactInfo: true,
            accountLimits: true,
            addAffiliatedCompanies: false,
        },
        driver: {
            create: true,
            update: true,
            delete: true,
            resetPassword: true,
        },
        vehicle: {
            serialNumber: true,
            update: true,
            showActivationDate: false,
            vehicleExchange: true,
        },
        driverLog: {
            recreateElogChart: true,
            deleteAutoEvent: false,
        },
        vehicleDvir: true,
        driverLogPdf: true,
        fmcsaEldWebService: true,
        iftaReport: true,
        controlPanel: true,
        customerService: {
            modifyOrgCsm: true,
            modifyTask: true,
        },
    },
    6: {
        lv: 6,
        allOrgList: true,
        descripation: 'CustomerServiceSupervisor',
        instantLocation: true,
        historyLocationTracking: true,
        org: {
            create: true,
            address: true,
            contactInfo: true,
            modifySales: true,
            accountLimits: true,
            addAffiliatedCompanies: true,
        },
        driver: {
            create: true,
            update: true,
            delete: true,
            resetPassword: true,
        },
        vehicle: {
            activation: true,
            unitNumber: true,
            vin: true,
            serialNumber: true,
            update: true,
            deviceReturnDate: true,
            vehicleExchange: true,
        },
        driverLog: {
            recreateElogChart: true,
            deleteAutoEvent: true,
            showAllEvent: true,
        },
        vehicleDvir: true,
        driverLogPdf: true,
        fmcsaEldWebService: true,
        iftaReport: true,
        queryTable: true,
        controlPanel: true,
        commissionCalculation: true,
        customerService: {
            modifyResource: true,
            modifyOrgCsm: true,
            modifyTask: true,
        },
    },
    7: {
        lv: 7,
        allOrgList: true,
        descripation: 'Billing',
        instantLocation: true,
        historyLocationTracking: true,
        org: {
            address: true,
            contactInfo: true,
            activation: true,
            accountLimits: true,
            plusPlanLimits: true,
            addAffiliatedCompanies: true,
        },
        driver: {},
        vehicle: {
            servicePlan: true,
            contractDate: true,
            activationDate: true,
            renewPayment: true,
        },
        driverLog: {},
        queryTable: true,
        commissionCalculation: true,
        customerService: {
            modifyOrgCsm: true,
            modifyTask: true,
        },
    },
    8: {
        lv: 8,
        allOrgList: true,
        descripation: 'BillingSupervisor',
        instantLocation: true,
        historyLocationTracking: true,
        org: {
            address: true,
            contactInfo: true,
            activation: true,
            modifySales: true,
            vehicleLimits: true,
            accountLimits: true,
            plusPlanLimits: true,
            addAffiliatedCompanies: true,
        },
        driver: {},
        vehicle: {
            suspend: true,
            servicePlan: true,
            contractDate: true,
            activationDate: true,
            deviceReturnDate: true,
            renewPayment: true,
        },
        driverLog: {},
        queryTable: true,
        commissionCalculation: true,
        customerService: {
            modifyResource: true,
            modifyOrgCsm: true,
            modifyTask: true,
        },
    },
    9: {
        lv: 9,
        allOrgList: true,
        descripation: 'Admin',
        instantLocation: true,
        historyLocationTracking: true,
        org: {
            create: true,
            name: true,
            dotNumber: true,
            address: true,
            contactInfo: true,
            activation: true,
            modifySales: true,
            vehicleLimits: true,
            accountLimits: true,
            plusPlanLimits: true,
            addAffiliatedCompanies: true,
        },
        driver: {
            create: true,
            update: true,
            delete: true,
            resetPassword: true,
        },
        vehicle: {
            create: true,
            delete: true,
            activation: true,
            unitNumber: true,
            vin: true,
            serialNumber: true,
            update: true,
            showActivationDate: true,
            transfer: true,
            suspend: true,
            deviceReturnDate: true,
            vehicleExchange: true,
        },
        driverLog: {
            recreateElogChart: true,
            deleteElog: true,
            deleteAutoEvent: true,
            showAllEvent: true,
        },
        vehicleDvir: true,
        driverLogPdf: true,
        fmcsaEldWebService: true,
        iftaReport: true,
        queryTable: true,
        controlPanel: true,
        commissionCalculation: true,
        customerService: {
            modifyResource: true,
            modifyOrgCsm: true,
            modifyTask: true,
        },
    },
    10: {
        lv: 10,
        allOrgList: true,
        descripation: 'SuperAdmin',
        instantLocation: true,
        historyLocationTracking: true,
        org: {
            create: true,
            name: true,
            dotNumber: true,
            address: true,
            contactInfo: true,
            activation: true,
            modifySales: true,
            vehicleLimits: true,
            accountLimits: true,
            plusPlanLimits: true,
            addAffiliatedCompanies: true,
        },
        driver: {
            create: true,
            update: true,
            delete: true,
            resetPassword: true,
        },
        vehicle: {
            create: true,
            delete: true,
            activation: true,
            unitNumber: true,
            vin: true,
            serialNumber: true,
            update: true,
            showActivationDate: true,
            transfer: true,
            suspend: true,
            servicePlan: true,
            contractDate: true,
            activationDate: true,
            deviceReturnDate: true,
            vehicleExchange: true,
            renewPayment: true,
        },
        driverLog: {
            recreateElogChart: true,
            deleteElog: true,
            deleteAutoEvent: true,
            showAllEvent: true,
        },
        vehicleDvir: true,
        driverLogPdf: true,
        fmcsaEldWebService: true,
        iftaReport: true,
        queryTable: true,
        controlPanel: true,
        commissionCalculation: true,
        customerService: {
            modifyResource: true,
            modifyOrgCsm: true,
            modifyTask: true,
        },
    },
};

const ADMIN_LEVEL_EXAMPLE = {
    lv: 10,
    descripation: 'permission list',
    instantLocation: true,
    historyLocationTracking: false,
    org: {
        create: false,
        name: false,
        dotNumber: false,
        address: true,
        contactInfo: true,
        activation: false,
        modifySales: true,
        vehicleLimits: false,
        accountLimits: false,
        plusPlanLimits: false,
    },
    driver: {
        create: true,
        update: true,
        delete: true,
        resetPassword: false,
    },
    vehicle: {
        activation: false,
        unitNumber: false,
        vin: false,
        serialNumber: false,
        update: true,
        showActivationDate: true,
        transfer: false,
        suspend: false,
        servicePlan: false,
        contractDate: false,
        activationDate: false,
        deviceReturnDate: false,
        vehicleExchange: false,
        renewPayment: false,
    },
    driverLog: {
        recreateElogChart: true,
        deleteElog: false,
        deleteAutoEvent: false,
        showAllEvent: false,
    },
    vehicleDvir: true,
    driverLogPdf: true,
    fmcsaEldWebService: true,
    iftaReport: false,
    queryTable: false,
    controlPanel: false,
    customerService: {
        modifyResource: true,
        modifyOrgCsm: false,
        modifyTask: false,
    },
};



// WEBPACK FOOTER //
// ./src/data/constants.ts